import { useBehavior } from '../extensions/hooks/useBehavior';
import { useCardContext } from '../context/CardContext';
import { CardAction } from '../extensions/constants/BehaviorTypes';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function CardActions() {
  const {
    results,
    cardId,
    fromObjectId,
    refetch,
    toObjectTypeId,
    hasScope,
    isUngated,
    associationDefinition,
    objectPermissions,
    objectTypeDefinition,
    fromObjectTypeId,
    onRefetchLegacySidebar
  } = useCardContext();
  const CardActionComponent = useBehavior(CardAction, toObjectTypeId, hasScope, isUngated);
  const associationPrimaryDisplayLabel = objectTypeDefinition === null || objectTypeDefinition === void 0 ? void 0 : objectTypeDefinition.singularForm;
  const userPermissions = useMemo(() => {
    return {
      currentUserCanEdit: !!(objectPermissions !== null && objectPermissions !== void 0 && objectPermissions.currentUserCanEdit),
      currentUserCanEditAssociations: !!(objectPermissions !== null && objectPermissions !== void 0 && objectPermissions.currentUserCanEditAssociations),
      __typename: 'ObjectPermissions'
    };
  }, [objectPermissions]);
  const associationTypesData = useMemo(() => {
    return {
      associationCategory: (associationDefinition === null || associationDefinition === void 0 ? void 0 : associationDefinition.category.toString()) || '',
      associationTypeId: (associationDefinition === null || associationDefinition === void 0 ? void 0 : associationDefinition.id) || 0,
      associationPrimaryDisplayLabel: associationPrimaryDisplayLabel || null
    };
  }, [associationDefinition, associationPrimaryDisplayLabel]);
  if (!CardActionComponent || !associationDefinition) {
    return null;
  }
  const canCreate = objectPermissions === null || objectPermissions === void 0 ? void 0 : objectPermissions.currentUserCanCreate;
  const canEditAssociations = !!(objectPermissions !== null && objectPermissions !== void 0 && objectPermissions.currentUserCanEditAssociations);
  const canEditAssociation = !!(canEditAssociations || canCreate);
  const associatedObjectsIds = (results === null || results === void 0 ? void 0 : results.map(result => result.objectId.toString())) || [];
  const canEditAssociationMessageOverride = !canEditAssociation ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "cardAssociatedObjects.AssociateObjectButton.tooltip.permissionsTooltipTextV2"
  }) : undefined;
  return /*#__PURE__*/_jsx(CardActionComponent, {
    cardId: cardId,
    canEditAssociation: canEditAssociation,
    canEditAssociationMessageOverride: canEditAssociationMessageOverride,
    fromObjectTypeId: fromObjectTypeId,
    toObjectTypeId: toObjectTypeId,
    fromObjectId: fromObjectId,
    associatedObjectsIds: associatedObjectsIds,
    associationTypeData: associationTypesData,
    onRefetchLegacySidebar: onRefetchLegacySidebar,
    refetchObjectData: refetch,
    isUngated: isUngated,
    hasScope: hasScope,
    userPermissions: userPermissions,
    objectTypePermissions: objectPermissions
  });
}
export default CardActions;